import { Row } from "../../../../core/components/Row";
import { StartSection } from "../../../../core/components/StartSection";
import { TextComponent } from "../../../../core/components/TextComponent";
import guiaProveedoresData from "../../../../core/data/db_guia_proveedores.json";
import { CategoriesList } from "../components/CategoriesList";

export const AdditionalServices: React.FC = () => {
	const multimediaSection = guiaProveedoresData["Servicios Extra"];
	const categories = Array.isArray(multimediaSection.categorias) ? multimediaSection.categorias : [];

	return (
		<>
			<StartSection
				titulo={multimediaSection.titulo}
				backgroundImage={multimediaSection.imagen}
				description={multimediaSection.descripcion}
			/>
			{categories.map((category, index) => (
				<>
					<Row
						className="w-full gap-2 md:gap-4 p-5 mt-5 bg-white shadow"
						mainAxisAlignment="center"
						crossAxisAlignment="center"
					>
						<TextComponent
							variant="h1"
							className="font-baskerville font-bold text-center text-primarySunset "
						>
							{category.titulo_principal}
						</TextComponent>
					</Row>
					<main className="self-center w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem] mb-4 sm:mb-8">
						<div key={index}>
							<CategoriesList categories={category.categorias_detalle} />
						</div>
					</main>
				</>
			))}
		</>
	);
};
